import styled from 'styled-components';

interface AppWrapperProps {
    noPadding?: boolean;
}

export const LayoutWrapper = styled.div`
    height: 100%;
    margin: 0 auto;
    overflow: hidden!important;
    
`;

export const AppWrapper = styled.div<AppWrapperProps>`
    width:100%;
    height: auto; 
    overflow: hidden;
    background: #fff;
    padding: ${({ noPadding }) => (noPadding ? '0' : '15px 15px 80px 15px')}; 
    max-width: 1000px;
    margin:0 auto;
    box-sizing:border-box; 
`;

export const AppFooter = styled.div`
    position: sticky;
    bottom: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    max-width: 1000px;
    margin: 0 auto; 
    height: 65px!important;
`;

export const MenuModal = styled.div<{visible: boolean}>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.9);
    overflow: hidden;
    opacity: ${({ visible }) => (visible ? 1 : 0)};
    visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
    transition: opacity 0.3s ease, visibility 0.3s ease;
`;

export const CloseButton = styled.button`
    position: absolute;
    bottom: 40px;
    right: auto;
    left: auto;
    width: 56px;
    height: 56px;
    background-color: #FFF;
    border-radius: 50%;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

export const MenuIconsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 12px;
    overflow-y: scroll;
    scrollbar-width: none;
`;

export const MenuContainer = styled.div`
    display: flex;
    height: 100%;
    margin-top: 92px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 32px;
    background: linear-gradient(to top, rgba(27, 26,26, 1), rgba(27, 26, 26, 0));
    background-position: bottom;
    background-size: 100% 128px;
    background-repeat: no-repeat;
`;

export const Title = styled.span`
    font-size: 32px;
    line-height: 48px;
    font-weight: 700;
    color: #FFF;
`;
